{
  "questions": [
    {
      "id": "TOPO-NL-RIVIEREN-MAP-001",
      "module": "Topo",
      "skill": "nederland",
      "subSkill": "topo_rivieren_nl",
      "familyId": "TOPO-NL-RIVIEREN",
      "tier": 5,
      "group": 7,
      "levelCode": "E6",
      "conceptId": "topo_rivieren_maas_locatie",
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "questionType": "map_locate_line",
      "question": "Klik op de Maas op de kaart.",
      "context": "De Maas komt uit België het land binnen bij Eijsden en stroomt langs Maastricht, Roermond en Venlo.",
      "data": {
        "mapId": "nl-provinces",
        "targetRiverId": "NL-MAAS",
        "toleranceKm": 10,
        "referenceCityIds": ["NL-AMS", "NL-MST"]
      },
      "options": [],
      "correctAnswer": 0,
      "feedback": {
        "explanationText": "De Maas is de zuidelijkste hoofdrivier van Nederland. Hij komt binnen bij Eijsden, stroomt langs Maastricht, Roermond en Venlo, en mondt uiteindelijk via Noord-Brabant uit in het Hollands Diep.",
        "solutionSteps": [
          "Begin in het zuiden van Limburg (bij Maastricht).",
          "Volg de rivier naar het noorden via Roermond en Venlo.",
          "Doe daarna een knik naar het westen, dwars door Noord-Brabant.",
          "Eindigt bij het Hollands Diep."
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TOPO-NL-RIVIEREN-MAP-002",
      "module": "Topo",
      "skill": "nederland",
      "subSkill": "topo_rivieren_nl",
      "familyId": "TOPO-NL-RIVIEREN",
      "tier": 5,
      "group": 7,
      "levelCode": "E6",
      "conceptId": "topo_rivieren_waal_locatie",
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "questionType": "map_locate_line",
      "question": "Klik op de Waal op de kaart.",
      "context": "De Waal is de grootste tak van de Rijn en stroomt langs Nijmegen.",
      "data": {
        "mapId": "nl-provinces",
        "targetRiverId": "NL-WAAL",
        "toleranceKm": 10,
        "referenceCityIds": ["NL-NIJ", "NL-RTM"]
      },
      "options": [],
      "correctAnswer": 0,
      "feedback": {
        "explanationText": "De Waal is de zuidelijke en grootste tak van de Rijn. Hij stroomt langs Nijmegen, Tiel en Gorinchem richting Rotterdam.",
        "solutionSteps": [
          "Begin bij Lobith waar de Rijn binnenkomt.",
          "Volg de zuidelijke tak — die loopt langs Nijmegen.",
          "Vervolg langs Tiel en Gorinchem.",
          "Eindigt in de buurt van Rotterdam."
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TOPO-NL-RIVIEREN-MAP-003",
      "module": "Topo",
      "skill": "nederland",
      "subSkill": "topo_rivieren_nl",
      "familyId": "TOPO-NL-RIVIEREN",
      "tier": 5,
      "group": 7,
      "levelCode": "E6",
      "conceptId": "topo_rivieren_ijssel_locatie",
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "questionType": "map_locate_line",
      "question": "Klik op de IJssel op de kaart.",
      "context": "De IJssel is de noordelijke tak van de Rijn en stroomt naar het IJsselmeer.",
      "data": {
        "mapId": "nl-provinces",
        "targetRiverId": "NL-IJSSEL",
        "toleranceKm": 10,
        "referenceCityIds": ["NL-ZWL", "NL-DVT"]
      },
      "options": [],
      "correctAnswer": 0,
      "feedback": {
        "explanationText": "De IJssel splitst zich bij Westervoort van de Rijn en stroomt noordwaarts langs Doesburg, Zutphen, Deventer en Kampen tot in het IJsselmeer.",
        "solutionSteps": [
          "Vlak bij de Duitse grens splitst de Rijn zich.",
          "De noordelijke tak heet de IJssel.",
          "Volg de rivier omhoog langs Zutphen en Deventer.",
          "Eindigt bij Kampen in het IJsselmeer."
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TOPO-NL-RIVIEREN-MAP-004",
      "module": "Topo",
      "skill": "nederland",
      "subSkill": "topo_rivieren_nl",
      "familyId": "TOPO-NL-RIVIEREN",
      "tier": 5,
      "group": 7,
      "levelCode": "E6",
      "conceptId": "topo_rivieren_lek_locatie",
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "questionType": "map_locate_line",
      "question": "Klik op de Rijn op de kaart, het stukje voor de splitsing.",
      "context": "De Rijn komt binnen bij Lobith en splitst zich daarna in Waal, Nederrijn en IJssel.",
      "data": {
        "mapId": "nl-provinces",
        "targetRiverId": "NL-RIJN",
        "toleranceKm": 12,
        "referenceCityIds": ["NL-ARN"]
      },
      "options": [],
      "correctAnswer": 0,
      "feedback": {
        "explanationText": "De Rijn komt vanuit Duitsland Nederland binnen bij Lobith. Het ongesplitste stukje is maar kort — al snel splitst de rivier zich in Waal (zuid), Nederrijn (midden) en IJssel (noord).",
        "solutionSteps": [
          "Zoek het oostelijke uiteinde, vlak bij de Duitse grens.",
          "Daar komt de Rijn Nederland binnen, bij Lobith.",
          "Het kleine stuk vóór de splitsing is wat we 'de Rijn' noemen op de kaart."
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TOPO-NL-RIVIEREN-MAP-005",
      "module": "Topo",
      "skill": "nederland",
      "subSkill": "topo_rivieren_nl",
      "familyId": "TOPO-NL-RIVIEREN",
      "tier": 5,
      "group": 7,
      "levelCode": "E6",
      "conceptId": "topo_rivieren_nederrijn_locatie",
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "questionType": "map_locate_line",
      "question": "Klik op de Westerschelde op de kaart.",
      "context": "De Westerschelde is een brede zeearm in Zeeland en de monding van de Schelde.",
      "data": {
        "mapId": "nl-provinces",
        "targetRiverId": "NL-WESTERSCHELDE",
        "toleranceKm": 12,
        "referenceCityIds": ["NL-MID", "NL-VLI"]
      },
      "options": [],
      "correctAnswer": 0,
      "feedback": {
        "explanationText": "De Westerschelde is een brede zeearm in Zeeland — het laatste deel van de Schelde voordat die uitmondt in de Noordzee. Belangrijke vaarroute richting Antwerpen.",
        "solutionSteps": [
          "Kijk naar Zeeland, helemaal in het zuidwesten.",
          "De Westerschelde is de brede waterweg tussen Zeeuws-Vlaanderen en de rest van Zeeland.",
          "Hij verbindt Antwerpen met de Noordzee."
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TOPO-NL-RIVIEREN-MAP-006",
      "module": "Topo",
      "skill": "nederland",
      "subSkill": "topo_rivieren_nl",
      "familyId": "TOPO-NL-RIVIEREN",
      "tier": 5,
      "group": 7,
      "levelCode": "E6",
      "conceptId": "topo_rivieren_nederrijn_lek_locatie",
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "questionType": "map_locate_line",
      "question": "Klik op de Nederrijn / Lek op de kaart.",
      "context": "De Nederrijn wordt verder stroomafwaarts (na Wijk bij Duurstede) de Lek genoemd.",
      "data": {
        "mapId": "nl-provinces",
        "targetRiverId": "NL-NEDERRIJN-LEK",
        "toleranceKm": 10,
        "referenceCityIds": ["NL-UTR", "NL-ARN"]
      },
      "options": [],
      "correctAnswer": 0,
      "feedback": {
        "explanationText": "De Nederrijn is de middelste tak van de Rijn. Bij Wijk bij Duurstede verandert zijn naam in 'Lek'. De rivier stroomt langs Arnhem, Wageningen, Wijk bij Duurstede en Schoonhoven.",
        "solutionSteps": [
          "Begin bij de splitsing van de Rijn, vlak bij Arnhem.",
          "De middelste tak heet Nederrijn.",
          "Vanaf Wijk bij Duurstede wordt diezelfde rivier 'Lek' genoemd.",
          "Hij komt uiteindelijk samen met de Waal bij Rotterdam."
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}